import { NamedComplexEnum } from '../../utils/complexEnum/NamedComplexEnum'
import { NotificationEventItem } from './NotificationEventItem'

/**
 * a wrapper to enforce the fact that notification event items need to extend
 * {@link NotificationEventItem}
 *
 * use this when defining any new NotificationEvent enums
 *
 * @see {@link NotificationEventEnum}
 * @see {@link NotificationEventItem}
 * @see {@link DetailedComplexEnumItem}
 */
export abstract class NotificationEventEnum<
  Typename extends string,
  ItemType extends NotificationEventItem<Name, ID>,
  Name extends string,
  ID extends Lowercase<string>
> extends NamedComplexEnum<Typename, ItemType, Name, ID> {}
